import { ProductType } from '../../store/AuthSlice';
import { v4 as uuidv4 } from 'uuid';

export const todayFormatted = new Date().toLocaleDateString('ru-RU');
export const defaultProducts: ProductType[] = [
  {
    id: uuidv4(),
    food_name: 'cheese',
    nf_protein: 25,
    nf_total_fat: 17.2,
    nf_total_carbohydrate: 0,
    nf_calories: 254.8,
    isDefault: true,
    weight: 100,
  },
  {
    id: uuidv4(),
    food_name: 'egg',
    nf_protein: 12.8,
    nf_total_fat: 11.6,
    nf_total_carbohydrate: 0.3,
    nf_calories: 140,
    isDefault: true,
    weight: 100,
  },
  {
    id: uuidv4(),
    food_name: 'tomato',
    nf_protein: 1.1,
    nf_total_fat: 0.2,
    nf_total_carbohydrate: 3.8,
    nf_calories: 24,
    isDefault: true,
    weight: 100,
  },
  {
    id: uuidv4(),
    food_name: 'persimmon',
    nf_protein: 0.5,
    nf_total_fat: 0.4,
    nf_total_carbohydrate: 15.3,
    nf_calories: 67,
    isDefault: true,
    weight: 100,
  },
  {
    id: uuidv4(),
    food_name: 'prunes',
    nf_protein: 1.6,
    nf_total_fat: 0.4,
    nf_total_carbohydrate: 55.4,
    nf_calories: 229,
    isDefault: true,
    weight: 100,
  },
  {
    id: uuidv4(),
    food_name: 'chicken breast',
    nf_protein: 31,
    nf_total_fat: 3.6,
    nf_total_carbohydrate: 0,
    nf_calories: 165,
    isDefault: true,
    weight: 100,
  },
  {
    id: uuidv4(),
    food_name: 'salmon',
    nf_protein: 25,
    nf_total_fat: 13,
    nf_total_carbohydrate: 0,
    nf_calories: 208,
    isDefault: true,
    weight: 100,
  },
  {
    id: uuidv4(),
    food_name: 'almonds',
    nf_protein: 21,
    nf_total_fat: 49,
    nf_total_carbohydrate: 22,
    nf_calories: 576,
    isDefault: true,
    weight: 100,
  },
  {
    id: uuidv4(),
    food_name: 'banana',
    nf_protein: 1.3,
    nf_total_fat: 0.3,
    nf_total_carbohydrate: 27,
    nf_calories: 105,
    isDefault: true,
    weight: 100,
  },
  {
    id: uuidv4(),
    food_name: 'broccoli',
    nf_protein: 2.8,
    nf_total_fat: 0.4,
    nf_total_carbohydrate: 6.6,
    nf_calories: 34,
    isDefault: true,
    weight: 100,
  },
  {
    id: uuidv4(),
    food_name: 'carrot',
    nf_protein: 0.9,
    nf_total_fat: 0.2,
    nf_total_carbohydrate: 9.6,
    nf_calories: 41,
    isDefault: true,
    weight: 100,
  },
  {
    id: uuidv4(),
    food_name: 'potato',
    nf_protein: 2,
    nf_total_fat: 0.1,
    nf_total_carbohydrate: 17,
    nf_calories: 77,
    isDefault: true,
    weight: 100,
  },
  {
    id: uuidv4(),
    food_name: 'spinach',
    nf_protein: 2.9,
    nf_total_fat: 0.4,
    nf_total_carbohydrate: 3.6,
    nf_calories: 23,
    isDefault: true,
    weight: 100,
  },
  {
    id: uuidv4(),
    food_name: 'apple',
    nf_protein: 0.3,
    nf_total_fat: 0.2,
    nf_total_carbohydrate: 14,
    nf_calories: 52,
    isDefault: true,
    weight: 100,
  },
  {
    id: uuidv4(),
    food_name: 'blueberries',
    nf_protein: 0.7,
    nf_total_fat: 0.3,
    nf_total_carbohydrate: 14.5,
    nf_calories: 57,
    isDefault: true,
    weight: 100,
  },
  {
    id: uuidv4(),
    food_name: 'avocado',
    nf_protein: 2,
    nf_total_fat: 15,
    nf_total_carbohydrate: 9,
    nf_calories: 160,
    isDefault: true,
    weight: 100,
  },
  {
    id: uuidv4(),
    food_name: 'beef steak',
    nf_protein: 26,
    nf_total_fat: 15,
    nf_total_carbohydrate: 0,
    nf_calories: 250,
    isDefault: true,
    weight: 100,
  },
  {
    id: uuidv4(),
    food_name: 'rice',
    nf_protein: 2.7,
    nf_total_fat: 0.3,
    nf_total_carbohydrate: 28,
    nf_calories: 130,
    isDefault: true,
    weight: 100,
  },
  {
    id: uuidv4(),
    food_name: 'lentils',
    nf_protein: 9,
    nf_total_fat: 0.4,
    nf_total_carbohydrate: 20,
    nf_calories: 116,
    isDefault: true,
    weight: 100,
  },
  {
    id: uuidv4(),
    food_name: 'peanut butter',
    nf_protein: 25,
    nf_total_fat: 50,
    nf_total_carbohydrate: 20,
    nf_calories: 588,
    isDefault: true,
    weight: 100,
  },
  {
    id: uuidv4(),
    food_name: 'cucumber',
    nf_protein: 0.7,
    nf_total_fat: 0.1,
    nf_total_carbohydrate: 3.6,
    nf_calories: 15,
    isDefault: true,
    weight: 100,
  },
  {
    id: uuidv4(),
    food_name: 'orange',
    nf_protein: 0.9,
    nf_total_fat: 0.1,
    nf_total_carbohydrate: 12,
    nf_calories: 47,
    isDefault: true,
    weight: 100,
  },
  {
    id: uuidv4(),
    food_name: 'walnuts',
    nf_protein: 15,
    nf_total_fat: 65,
    nf_total_carbohydrate: 14,
    nf_calories: 654,
    isDefault: true,
    weight: 100,
  },
  {
    id: uuidv4(),
    food_name: 'milk',
    nf_protein: 3.4,
    nf_total_fat: 3.3,
    nf_total_carbohydrate: 4.8,
    nf_calories: 61,
    isDefault: true,
    weight: 100,
  },
  {
    id: uuidv4(),
    food_name: 'yogurt',
    nf_protein: 10,
    nf_total_fat: 2,
    nf_total_carbohydrate: 4,
    nf_calories: 63,
    isDefault: true,
    weight: 100,
  },
];
